module.exports = __webpack_public_path__ + "img/campaign.04a64a57.jpg";